class MapMaker{

	constructor() {

	}

	createDynamicMap(element){

		let map = new google.maps.Map(element, {
			zoom: 10,
			clickableIcons: false,
			streetViewControl: false,
			mapTypeControl: false,
			fullscreenControl: false,
			zoomControl: false,
			gestureHandling: "cooperative",
			mapId: mcubeArgs.gmapMapId
		});

		map.bounds = new google.maps.LatLngBounds();
		map.infowindowOpen = null;
		map.markers = [];
		this.zoomControls(element, map);
		return map;

	}

	createStaticMap(element, markers){

		let imgWidth = "640";
		let imgHeight = "640";
		if(element.classList.contains('map-fullwidth')){
			imgHeight = "360";
		}

		let url = "https://maps.googleapis.com/maps/api/staticmap?";
		url += "key=" + mcubeArgs.gmapApiKey;
		url += "&map_id=" + mcubeArgs.gmapMapId;
		url += "&size=" + imgWidth + "x" + imgHeight;
		url += "&scale=2";
		url += "&format=JPEG";

		if( markers.length === 1 ){
			url += "&center=" + markers[0].dataset.markerLat + "," + markers[0].dataset.markerLng;
			url += "&zoom=" + element.dataset.zoom;
		}

		markers.forEach( (marker) => {
			url += "&markers=";
			url += marker.dataset.markerLat + "," + marker.dataset.markerLng;
			if( marker.dataset.pointer ){
				url += "|icon:" + encodeURI(marker.dataset.pointer);
			}
		});

		let image = new Image();
		image.src = url;
		image.width = imgWidth;
		image.height = imgHeight;
		element.appendChild(image);

	}

	zoomControls(element, map) {
		let mapContainer = element.closest('.map-container');
		if( !mapContainer )
			return;
		let zoomIn = mapContainer.querySelector('.map-zoom-in');
		if (zoomIn) {
			zoomIn.addEventListener('click', () => {
				map.setZoom(map.getZoom() + 1);
			});
		}

		let zoomOut = mapContainer.querySelector('.map-zoom-out');
		if (zoomOut) {
			zoomOut.addEventListener('click', () => {
				map.setZoom(map.getZoom() - 1);
			});
		}
	}

	createMarker(marker, map){

		let m = new google.maps.Marker({
			position: {
				lat: parseFloat(marker.dataset.markerLat),
				lng: parseFloat(marker.dataset.markerLng)
			},
			map: map,
		});

		let infowindow = marker.querySelector(".map-marker-inner");
		if( infowindow ) {
			m.infowindow = new google.maps.InfoWindow({
				content: infowindow.innerHTML,
				maxWidth: 240
			});

			m.addListener('click', () => {
				if( map.infowindowOpen ){
					map.infowindowOpen.close();
				}
				m.infowindow.open({
					anchor: m,
					map
				});
				map.infowindowOpen = m.infowindow;
				map.setCenter(m.getPosition());
			});
		}
		if( marker.dataset.pointer ){
			m.pointer = marker.dataset.pointer;
			m.pointerSize = marker.dataset.pointerSize;
			m.pointerAnchor = marker.dataset.pointerAnchor;
			m.pointerHover = marker.dataset.pointerHover;
			m.setIcon( this.createIcon(m.pointer, m.pointerSize, m.pointerAnchor) );
		}

		if( marker.dataset.markerId ){
			m.id = marker.dataset.markerId;
			map.markers[m.id] = m;
		}else{
			map.markers.push(m);
		}
		map.bounds.extend(m.getPosition());
	}

	createIcon(icon, size, anchor){
		let s = size.split('x');
		let a = [s[0]/2,s[1]];
		if( anchor ) {
			a = anchor.split(';');
		}
		return {
			url: icon,
			size: new google.maps.Size(s[0], s[1]),
			scaledSize: new google.maps.Size(s[0], s[1]),
			origin: new google.maps.Point(0, 0),
			anchor: new google.maps.Point(a[0], a[1])
		};
	}

	initMarkerClusterer(map){

		loadScript.load("/wp-content/themes/smartto/lib/markerclustererplus.min.js", () => {

			const styles = [
				[
					{
						width: 60,
						height: 60
					}
				]
			];

			map.clusterer = new MarkerClusterer(map, [], {
				gridSize: 40,
				clusterClass: 'custom-clustericon',
				styles: styles[0],
				ignoreHidden: true
			});

			map.clusterer.addMarkers(map.markers);

		});

	}

	markerRelationShip(map, relation){

		let list = document.querySelectorAll(relation);
		list.forEach( (item) => {
			item.addEventListener('mouseenter', (c) => {
				this.cardEvents(map, 'enter', item.dataset.markerId);
			});
			item.addEventListener('mouseleave', (c) => {
				this.cardEvents(map, 'leave', item.dataset.markerId);
			});
			item.addEventListener('click', (c) => {
				this.cardEvents(map, 'click', item.dataset.markerId);
			});
		});

	}

	cardEvents(map, event, id) {
		let clusterers = map.clusterer.getClusters();
		if (event === "enter") {

			clusterers.forEach((cluster) => {
				cluster.markers_.forEach((m) => {
					if (m.id === id && cluster.markers_.length >= map.clusterer.minClusterSize_) {
						cluster.clusterIcon_.div_.className = 'custom-clustericon-hover';
						return false;
					}
				});
			});
			map.markers.forEach( (marker) => {
				if (marker.id === id) {
					marker.setIcon( this.createIcon(marker.pointerHover, marker.pointerSize, marker.pointerAnchor) );
				}
			});

		} else if (event === "leave") {

			clusterers.forEach((cluster) => {
				cluster.markers_.forEach((m) => {
					if (m.id === id && cluster.markers_.length >= map.clusterer.minClusterSize_) {
						cluster.clusterIcon_.div_.className = 'custom-clustericon';
						return false;
					}
				});
			});
			map.markers.forEach( (marker) => {
				if (marker.id === id) {
					marker.setIcon( this.createIcon(marker.pointer, marker.pointerSize, marker.pointerAnchor) );
				}
			});

		} else if (event === "click") {

			let find = null;
			clusterers.forEach((cluster, index) => {
				cluster.markers_.forEach((m) => {
					if (m.id === id && cluster.markers_.length >= map.clusterer.minClusterSize_) {
						find = true;
						return false;
					}
				});
			});

			if(find){
				map.setZoom(12);
			}
			google.maps.event.trigger(map.markers[id], 'click');

		}
	}

}